
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.2421',
  depVersions: {
  "customer-portal-app": "static-1.2421",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.469",
  "data-fetching-client": "static-1.9700",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.455",
  "growth-payments-core": "static-1.25491",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5625",
  "hs-test-utils": "static-1.8049",
  "hub-http": "static-1.6257",
  "hub-http-shared-msw-handlers": "static-1.10053",
  "hubspot-dlb": "static-2.1854",
  "hubspot-prosemirror": "static-1.18340",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11507",
  "I18n": "static-7.1631",
  "immutable": "static-2.79",
  "jasmine-runner": "static-1.6498",
  "payment-link-components": "static-1.23622",
  "prosemirror": "static-1.13",
  "quartz": "static-1.7075",
  "quartz-core": "static-1.6294",
  "quartz-i18n": "static-1.750",
  "react": "static-7.186",
  "react-colorpicker": "static-2.10242",
  "react-dlb": "static-1.79",
  "react-utils": "static-2.5370",
  "rich-text-lib": "static-1.19891",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.18048",
  "ui-components-test-utils": "static-1.5644",
  "UIComponents": "static-3.8453",
  "foundations-assets": "static-1.4903",
  "foundations-components": "static-1.8000",
  "foundations-theming": "static-1.4454",
  "foundations-theming-specialty": "static-1.2170",
  "framer-motion": "static-1.72",
  "metrics-js": "static-1.9637",
  "PortalIdParser": "static-2.404",
  "portals-platform-lib": "static-1.953",
  "quartz-config": "static-1.853",
  "quartz-routing": "static-1.505",
  "quick-fetch": "static-1.3942",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16709",
  "rpc-client-utils": "static-1.4687",
  "sanitize-text": "static-1.8177",
  "styled-components": "static-2.89",
  "tanstack-table": "static-1.55",
  "ui-addon-draggable": "static-3.4797",
  "ui-addon-react-router-dom": "static-1.9576",
  "usage-tracker": "static-1.7382",
  "usage-tracker-anonymous": "static-1.5799",
  "usage-tracker-core": "static-1.7232",
  "video-components-external": "static-1.11419",
  "apollo-stack-hubspot": "static-3.84",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3425",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3352",
  "quartz-webpack": "static-1.3299",
  "bend-plugin-quartz-routing": "static-1.153",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.82",
  "customer-data-objects": "static-1.7708",
  "frontend-preferences-client": "static-1.7962",
  "laboratory-lib": "static-3.7190",
  "onboarding-scopes": "static-1.6495",
  "seat-types-lib": "static-1.100",
  "ui-addon-opt": "static-4.8398",
  "HeadJS": "static-2.764",
  "hs-test-utils-bend-plugin": "static-1.3160",
  "msw": "static-1.39",
  "testing-library": "static-1.152",
  "hs-locale-management": "static-1.107",
  "ts-schema": "static-1.4106",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.7803",
  "cssUtils": "static-1.798",
  "customer-data-ui-utilities": "static-1.9860",
  "HubStyle": "static-2.11814",
  "knowledge-content-types": "static-1.8504",
  "PatternValidationJS": "static-1.437",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.488",
  "ui-addon-emoji-picker": "static-1.9922",
  "ui-addon-i18n": "static-1.11183",
  "ui-business-units-lib": "static-1.9091",
  "ui-shepherd-react": "static-3.10215",
  "i18n-data": "static-1.221",
  "moment-timezone": "static-5.83",
  "jasmine": "static-4.4361",
  "commerce-tours-lib": "static-1.6169",
  "customer-data-properties": "static-1.51700",
  "getting-started-shared-tasks": "static-1.18552",
  "growth-onboarding-reliability": "static-1.5116",
  "onboarding-tours": "static-1.16672",
  "reference-resolvers-lite": "static-1.8130",
  "sales-checkout-service-client": "static-1.3677",
  "ui-addon-iframeable": "static-1.9095",
  "user-context": "static-1.5140",
  "dispatcher": "static-1.137",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.838",
  "hubspotter-http": "static-1.4677",
  "icons": "static-2.650",
  "mobile-manifest-mixins": "static-1.538",
  "module-federation": "static-1.23",
  "quartz-auth": "static-1.750",
  "quartz-head": "static-1.740",
  "quartz-test": "static-1.750",
  "quartz-tracking": "static-1.454",
  "ui-fonts": "static-1.769",
  "usage-tracker-container": "static-1.7372",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9458",
  "data-token-picker": "static-1.16465",
  "FileManagerLib": "static-1.39362",
  "property-translator": "static-1.5433",
  "atom": "static-1.5108",
  "merchandise-lib": "static-1.264",
  "purchase-motions-components": "static-1.5982",
  "salesImages": "static-1.525",
  "SharedI18nStrings": "static-1.182",
  "foundations-components-test-utils": "static-1.5483",
  "react-select-plus": "static-1.105",
  "react-virtualized": "static-2.99",
  "ui-images": "static-2.1160",
  "bend-plugin-foundations-components": "static-1.4269",
  "floating-ui": "static-1.56",
  "react-aria": "static-1.66",
  "react-create-root-preference": "static-1.29",
  "trellis-assets": "static-1.2040",
  "bend-plugin-foundations-theming": "static-1.2937",
  "foundations-theming-base": "static-1.3439",
  "stylex": "static-1.33",
  "interframe": "static-3.4794",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.5796",
  "web-vitals": "static-1.6",
  "bend-plugin-chirp-manifest": "static-1.97",
  "chirp-fetch": "static-1.1922",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4510",
  "react-flip-move": "static-1.70",
  "apollo-link-hub-http": "static-2.4686",
  "content-media-composition-data-lib": "static-1.12462",
  "content-media-compositions": "static-2.16469",
  "idb-keyval": "static-1.44",
  "immer": "static-1.33",
  "immerable": "static-1.4188",
  "magpie-lib": "static-1.5573",
  "magpie-types": "static-1.5033",
  "media-bridge-lib": "static-1.18984",
  "video-data-lib": "static-1.35077",
  "bender-build-tools": "static-1.3227",
  "inbound-db-properties-service-client": "static-1.3872",
  "superstore": "static-1.4795",
  "feedback-loader": "static-1.29361",
  "ai-components-ui-library": "static-1.9065",
  "ui-addon-video-player": "static-1.8737",
  "ui-coaching-tips": "static-1.28670",
  "sassPrefix": "static-1.156",
  "react-dnd-compat": "static-1.4649",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "avatar-components": "static-1.2533",
  "navigation-messaging": "static-1.7459",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8206",
  "reselect": "static-2.16",
  "commerce-products-lib": "static-1.9705",
  "crm-message-bus": "static-1.43073",
  "growth-data-modal": "static-1.5480",
  "hubspot-apollo-client": "static-1.4913",
  "onboarding-tours-client": "static-1.4886",
  "calling-global-api": "static-1.64645",
  "calling-internal-common": "static-1.31337",
  "calling-lifecycle-internal": "static-1.66027",
  "calling-lifecycle-messages": "static-1.58321",
  "conditional-properties-service-client": "static-1.3823",
  "crm-links": "static-1.6335",
  "customer-data-objects-ui-components": "static-1.13064",
  "customer-data-properties-shared-msw-handlers": "static-1.9380",
  "customer-data-property-utils": "static-1.8126",
  "external-options-client-types": "static-1.4185",
  "file-manager-components": "static-1.23722",
  "framework-data-schema-resolvers": "static-1.6920",
  "google-libphonenumber": "static-1.38",
  "hs-resources": "static-1.191",
  "inbound-db-meta-service-client": "static-1.3612",
  "inbounddb-objects-service-types": "static-1.4249",
  "meetings-icalendar-utils-lib": "static-1.666",
  "multi-currency-client-types": "static-1.3717",
  "object-builder-ui-client": "static-1.48877",
  "pipeline-validation-client-types": "static-1.3991",
  "property-value-citations": "static-1.2314",
  "pulse": "static-1.615",
  "smart-property-lib": "static-1.7281",
  "tiered-pricing": "static-1.1299",
  "zustand": "static-1.74",
  "ui-addon-form-validation": "static-1.11024",
  "growth-onboarding-confetti": "static-1.3101",
  "growth-onboarding-next-action-utils": "static-1.2033",
  "navigation-components": "static-1.18132",
  "onboarding-tours-utils": "static-1.738",
  "ui-shepherd-tracker": "static-1.7596",
  "ui-universal-auth": "static-1.9018",
  "batch-promise": "static-1.1576",
  "getting-started-shared-tasks-store": "static-1.17670",
  "hubspotter-http-shared-msw-handlers": "static-1.10051",
  "usage-tracker-session-replay": "static-1.5068",
  "audio-components": "static-1.5966",
  "FileManagerCore": "static-1.39221",
  "FileManagerImages": "static-1.36873",
  "video-components": "static-1.13421",
  "foundations-components-legacy": "static-1.1025",
  "purchase-motions-api": "static-1.5985",
  "signup-constants": "static-1.18904",
  "signup-ui-url-generator": "static-2.8088",
  "usage-tracker-public": "static-1.7193",
  "reactive-lib": "static-1.757",
  "simple-logging-lib": "static-1.3085",
  "chatspot-core": "static-1.21451",
  "ContentUtils": "static-1.68478",
  "copilot-toolkit": "static-1.11229",
  "growth-onboarding-feedback-components": "static-1.6614",
  "commerce-permissions": "static-1.808",
  "customer-data-tracking": "static-1.6924",
  "products-iframe-lib": "static-1.8044",
  "products-ui-components-shared-msw-handlers": "static-1.10435",
  "restore-request-side-panel-lib": "static-1.1003",
  "onboarding-data-sync-lib": "static-1.2009",
  "hubspot-apollo-cache": "static-1.372",
  "calling-error-reporting": "static-1.31344",
  "shared-worker-versioning": "static-1.11071",
  "calling-usage-tracker": "static-1.6575",
  "self-service-api": "static-1.10282",
  "voice-sms-access-library": "static-1.1154",
  "conversations-skeleton-state": "static-1.7282",
  "location-customization-utils-lib": "static-1.9377",
  "crm-pipelines-api-client-types": "static-1.4165",
  "fdsr-migration-layer": "static-1.39",
  "framework-builder-read-service-client": "static-1.4031",
  "framework-data-schema-quick-fetch": "static-1.6825",
  "persist-promise": "static-1.3733",
  "bend-plugin-pulse": "static-1.118",
  "event-emitter": "static-1.982",
  "fast-json-patch": "static-1.63",
  "data-agent-kit": "static-1.247",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10136",
  "fsm": "static-1.3766",
  "policy-lib": "static-1.6811",
  "react-tinymce": "static-1.55354",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10199",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54480",
  "tinymce-plugins": "static-1.57594",
  "tinymce-themes": "static-1.56450",
  "growth-onboarding-next-action-components": "static-1.2061",
  "user-context-client": "static-1.4646",
  "nest": "static-1.264",
  "unified-auth-core-lib": "static-1.814",
  "amplitude-session-replay-browser": "static-1.61",
  "cropperjs": "static-1.10",
  "redux-toolkit": "static-1.7",
  "urlinator": "static-1.4571",
  "video-embed": "static-1.35911",
  "content-icons-ui": "static-1.2233",
  "social-insights-client-types": "static-1.22217",
  "markdown-it": "static-1.6",
  "cms-field-types": "static-1.4847",
  "integrations-lib": "static-1.16294",
  "underscore": "static-1.8",
  "breeze-engine-lib": "static-1.767",
  "sales-views-client-types": "static-1.4294",
  "InboxConnectUtils": "static-4.14921",
  "meetings-connect-utils-lib": "static-1.7639",
  "calling-orchestration-schema": "static-1.35931",
  "crm-record-cards-service-types": "static-1.3615",
  "highcharts": "static-8.104",
  "trellis-story-utils": "static-1.4549",
  "storybook-react": "static-1.33",
  "hub-http-contrib": "static-1.3076",
  "tinymce-data": "static-1.40565",
  "ui-addon-sales-email": "static-1.5245",
  "codemirror": "static-5.95",
  "layout-dnd-components": "static-1.12508",
  "layout-dnd-utils": "static-1.11483",
  "react-codemirror": "static-1.10660",
  "ui-brand-identity-lib": "static-1.15438",
  "NamespacedHubStyle": "static-2.9084",
  "outpost": "static-1.4213",
  "flux-actions": "static-1.341",
  "integrations-error-boundary-lib": "static-1.13709",
  "integrations-tracking-lib": "static-1.5637",
  "native-integrations-shared-strings": "static-1.7816",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10400",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.532",
  "ably": "static-2.2",
  "highlight.js": "static-1.79",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68553",
  "layout-data-lib": "static-1.9808",
  "browser-eslint": "static-2.57",
  "universal-page-editor-lib": "static-1.3048",
  "google-sheets-integration-lib": "static-1.353",
  "microsoft-drive-integration-lib": "static-1.481",
  "slack-ui-library": "static-1.10427",
  "advanced-menus-core": "static-1.15180",
  "advanced-menus-lib": "static-1.12118",
  "ExportDialog": "static-6.10419",
  "ui-memberships-settings-lib": "static-1.34155",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15179",
  "simple-menus-lib": "static-1.16696"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.2421",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.469",
  "data-fetching-client": "/data-fetching-client/static-1.9700",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.455",
  "growth-payments-core": "/growth-payments-core/static-1.25491",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5625",
  "hs-test-utils": "/hs-test-utils/static-1.8049",
  "hub-http": "/hub-http/static-1.6257",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10053",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18340",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11507",
  "I18n": "/I18n/static-7.1631",
  "immutable": "/immutable/static-2.79",
  "jasmine-runner": "/jasmine-runner/static-1.6498",
  "payment-link-components": "/payment-link-components/static-1.23622",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.7075",
  "quartz-core": "/quartz-core/static-1.6294",
  "quartz-i18n": "/quartz-i18n/static-1.750",
  "react": "/react/static-7.186",
  "react-colorpicker": "/react-colorpicker/static-2.10242",
  "react-dlb": "/react-dlb/static-1.79",
  "react-utils": "/react-utils/static-2.5370",
  "rich-text-lib": "/rich-text-lib/static-1.19891",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18048",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5644",
  "UIComponents": "/UIComponents/static-3.8453",
  "foundations-assets": "/foundations-assets/static-1.4903",
  "foundations-components": "/foundations-components/static-1.8000",
  "foundations-theming": "/foundations-theming/static-1.4454",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2170",
  "framer-motion": "/framer-motion/static-1.72",
  "metrics-js": "/metrics-js/static-1.9637",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "portals-platform-lib": "/portals-platform-lib/static-1.953",
  "quartz-config": "/quartz-config/static-1.853",
  "quartz-routing": "/quartz-routing/static-1.505",
  "quick-fetch": "/quick-fetch/static-1.3942",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16709",
  "rpc-client-utils": "/rpc-client-utils/static-1.4687",
  "sanitize-text": "/sanitize-text/static-1.8177",
  "styled-components": "/styled-components/static-2.89",
  "tanstack-table": "/tanstack-table/static-1.55",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4797",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9576",
  "usage-tracker": "/usage-tracker/static-1.7382",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5799",
  "usage-tracker-core": "/usage-tracker-core/static-1.7232",
  "video-components-external": "/video-components-external/static-1.11419",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3425",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3352",
  "quartz-webpack": "/quartz-webpack/static-1.3299",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.153",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.82",
  "customer-data-objects": "/customer-data-objects/static-1.7708",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7962",
  "laboratory-lib": "/laboratory-lib/static-3.7190",
  "onboarding-scopes": "/onboarding-scopes/static-1.6495",
  "seat-types-lib": "/seat-types-lib/static-1.100",
  "ui-addon-opt": "/ui-addon-opt/static-4.8398",
  "HeadJS": "/HeadJS/static-2.764",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3160",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.152",
  "hs-locale-management": "/hs-locale-management/static-1.107",
  "ts-schema": "/ts-schema/static-1.4106",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.7803",
  "cssUtils": "/cssUtils/static-1.798",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9860",
  "HubStyle": "/HubStyle/static-2.11814",
  "knowledge-content-types": "/knowledge-content-types/static-1.8504",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.488",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9922",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11183",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9091",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10215",
  "i18n-data": "/i18n-data/static-1.221",
  "moment-timezone": "/moment-timezone/static-5.83",
  "jasmine": "/jasmine/static-4.4361",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6169",
  "customer-data-properties": "/customer-data-properties/static-1.51700",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18552",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5116",
  "onboarding-tours": "/onboarding-tours/static-1.16672",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8130",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3677",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9095",
  "user-context": "/user-context/static-1.5140",
  "dispatcher": "/dispatcher/static-1.137",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.838",
  "hubspotter-http": "/hubspotter-http/static-1.4677",
  "icons": "/icons/static-2.650",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.538",
  "module-federation": "/module-federation/static-1.23",
  "quartz-auth": "/quartz-auth/static-1.750",
  "quartz-head": "/quartz-head/static-1.740",
  "quartz-test": "/quartz-test/static-1.750",
  "quartz-tracking": "/quartz-tracking/static-1.454",
  "ui-fonts": "/ui-fonts/static-1.769",
  "usage-tracker-container": "/usage-tracker-container/static-1.7372",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9458",
  "data-token-picker": "/data-token-picker/static-1.16465",
  "FileManagerLib": "/FileManagerLib/static-1.39362",
  "property-translator": "/property-translator/static-1.5433",
  "atom": "/atom/static-1.5108",
  "merchandise-lib": "/merchandise-lib/static-1.264",
  "purchase-motions-components": "/purchase-motions-components/static-1.5982",
  "salesImages": "/salesImages/static-1.525",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5483",
  "react-select-plus": "/react-select-plus/static-1.105",
  "react-virtualized": "/react-virtualized/static-2.99",
  "ui-images": "/ui-images/static-2.1160",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4269",
  "floating-ui": "/floating-ui/static-1.56",
  "react-aria": "/react-aria/static-1.66",
  "react-create-root-preference": "/react-create-root-preference/static-1.29",
  "trellis-assets": "/trellis-assets/static-1.2040",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2937",
  "foundations-theming-base": "/foundations-theming-base/static-1.3439",
  "stylex": "/stylex/static-1.33",
  "interframe": "/interframe/static-3.4794",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5796",
  "web-vitals": "/web-vitals/static-1.6",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.97",
  "chirp-fetch": "/chirp-fetch/static-1.1922",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4510",
  "react-flip-move": "/react-flip-move/static-1.70",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4686",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12462",
  "content-media-compositions": "/content-media-compositions/static-2.16469",
  "idb-keyval": "/idb-keyval/static-1.44",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4188",
  "magpie-lib": "/magpie-lib/static-1.5573",
  "magpie-types": "/magpie-types/static-1.5033",
  "media-bridge-lib": "/media-bridge-lib/static-1.18984",
  "video-data-lib": "/video-data-lib/static-1.35077",
  "bender-build-tools": "/bender-build-tools/static-1.3227",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3872",
  "superstore": "/superstore/static-1.4795",
  "feedback-loader": "/feedback-loader/static-1.29361",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9065",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8737",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28670",
  "sassPrefix": "/sassPrefix/static-1.156",
  "react-dnd-compat": "/react-dnd-compat/static-1.4649",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "avatar-components": "/avatar-components/static-1.2533",
  "navigation-messaging": "/navigation-messaging/static-1.7459",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8206",
  "reselect": "/reselect/static-2.16",
  "commerce-products-lib": "/commerce-products-lib/static-1.9705",
  "crm-message-bus": "/crm-message-bus/static-1.43073",
  "growth-data-modal": "/growth-data-modal/static-1.5480",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4913",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4886",
  "calling-global-api": "/calling-global-api/static-1.64645",
  "calling-internal-common": "/calling-internal-common/static-1.31337",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66027",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58321",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3823",
  "crm-links": "/crm-links/static-1.6335",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13064",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9380",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8126",
  "external-options-client-types": "/external-options-client-types/static-1.4185",
  "file-manager-components": "/file-manager-components/static-1.23722",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6920",
  "google-libphonenumber": "/google-libphonenumber/static-1.38",
  "hs-resources": "/hs-resources/static-1.191",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3612",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4249",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.666",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3717",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48877",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3991",
  "property-value-citations": "/property-value-citations/static-1.2314",
  "pulse": "/pulse/static-1.615",
  "smart-property-lib": "/smart-property-lib/static-1.7281",
  "tiered-pricing": "/tiered-pricing/static-1.1299",
  "zustand": "/zustand/static-1.74",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11024",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3101",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2033",
  "navigation-components": "/navigation-components/static-1.18132",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.738",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7596",
  "ui-universal-auth": "/ui-universal-auth/static-1.9018",
  "batch-promise": "/batch-promise/static-1.1576",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17670",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10051",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5068",
  "audio-components": "/audio-components/static-1.5966",
  "FileManagerCore": "/FileManagerCore/static-1.39221",
  "FileManagerImages": "/FileManagerImages/static-1.36873",
  "video-components": "/video-components/static-1.13421",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1025",
  "purchase-motions-api": "/purchase-motions-api/static-1.5985",
  "signup-constants": "/signup-constants/static-1.18904",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8088",
  "usage-tracker-public": "/usage-tracker-public/static-1.7193",
  "reactive-lib": "/reactive-lib/static-1.757",
  "simple-logging-lib": "/simple-logging-lib/static-1.3085",
  "chatspot-core": "/chatspot-core/static-1.21451",
  "ContentUtils": "/ContentUtils/static-1.68478",
  "copilot-toolkit": "/copilot-toolkit/static-1.11229",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6614",
  "commerce-permissions": "/commerce-permissions/static-1.808",
  "customer-data-tracking": "/customer-data-tracking/static-1.6924",
  "products-iframe-lib": "/products-iframe-lib/static-1.8044",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10435",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1003",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2009",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.372",
  "calling-error-reporting": "/calling-error-reporting/static-1.31344",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11071",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6575",
  "self-service-api": "/self-service-api/static-1.10282",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1154",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7282",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9377",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4165",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.39",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4031",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6825",
  "persist-promise": "/persist-promise/static-1.3733",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.118",
  "event-emitter": "/event-emitter/static-1.982",
  "fast-json-patch": "/fast-json-patch/static-1.63",
  "data-agent-kit": "/data-agent-kit/static-1.247",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10136",
  "fsm": "/fsm/static-1.3766",
  "policy-lib": "/policy-lib/static-1.6811",
  "react-tinymce": "/react-tinymce/static-1.55354",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10199",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54480",
  "tinymce-plugins": "/tinymce-plugins/static-1.57594",
  "tinymce-themes": "/tinymce-themes/static-1.56450",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2061",
  "user-context-client": "/user-context-client/static-1.4646",
  "nest": "/nest/static-1.264",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.814",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.61",
  "cropperjs": "/cropperjs/static-1.10",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "urlinator": "/urlinator/static-1.4571",
  "video-embed": "/video-embed/static-1.35911",
  "content-icons-ui": "/content-icons-ui/static-1.2233",
  "social-insights-client-types": "/social-insights-client-types/static-1.22217",
  "markdown-it": "/markdown-it/static-1.6",
  "cms-field-types": "/cms-field-types/static-1.4847",
  "integrations-lib": "/integrations-lib/static-1.16294",
  "underscore": "/underscore/static-1.8",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.767",
  "sales-views-client-types": "/sales-views-client-types/static-1.4294",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14921",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7639",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35931",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3615",
  "highcharts": "/highcharts/static-8.104",
  "trellis-story-utils": "/trellis-story-utils/static-1.4549",
  "storybook-react": "/storybook-react/static-1.33",
  "hub-http-contrib": "/hub-http-contrib/static-1.3076",
  "tinymce-data": "/tinymce-data/static-1.40565",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5245",
  "codemirror": "/codemirror/static-5.95",
  "layout-dnd-components": "/layout-dnd-components/static-1.12508",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11483",
  "react-codemirror": "/react-codemirror/static-1.10660",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15438",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9084",
  "outpost": "/outpost/static-1.4213",
  "flux-actions": "/flux-actions/static-1.341",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13709",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5637",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7816",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10400",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.532",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.79",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68553",
  "layout-data-lib": "/layout-data-lib/static-1.9808",
  "browser-eslint": "/browser-eslint/static-2.57",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3048",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.353",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.481",
  "slack-ui-library": "/slack-ui-library/static-1.10427",
  "advanced-menus-core": "/advanced-menus-core/static-1.15180",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12118",
  "ExportDialog": "/ExportDialog/static-6.10419",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34155",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15179",
  "simple-menus-lib": "/simple-menus-lib/static-1.16696"
}
};
